import { DEMRE } from '../endpoints';
import request from '../request';

export function getDemreConfig() {
  return request<{ enabled: boolean }>(DEMRE.CONFIG);
}
